import axios from 'axios'

export default {
  // ======================================================================
  // ==========================List Management=============================
  // ======================================================================
  boschpanelpointList (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/boschpanelpoint', { params: opts })
        .then(({ data }) => {
          context.commit('BOSCHPANELPOINT_LIST', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  // ==========================Socket Updates==============================
  boschpanelpointCreated (context, opts) {
    // do nothing
  },
  boschpanelpointUpdated (context, opts) {
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    const inputs = { }
    if (opts && Array.isArray(opts.populate) && opts.populate.length > 0) {
      inputs.params = { }
      inputs.params.populate = opts.populate
    }
    const inList = context.state.list.find((i) => i.id === id)
    if (context.state.current.id === id || inList) {
      axios
        .get(`/api/boschpanelpoint/${id}`, inputs)
        .then(({ data }) => {
          if (data.id === context.state.current.id) {
            context.commit('BOSCHPANELPOINT_CURRENT', data)
          }
          if (inList) {
            context.commit('BOSCHPANELPOINT_LIST_UPDATE', data)
          }
        }).catch(() => {
        })
    }
  },
  boschpanelpointDestroyed (context, opts) {
    // always try to remove from list
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    if (id === context.state.current.id) {
      context.commit('BOSCHPANELPOINT_CURRENT', null)
    }
    context.commit('BOSCHPANELPOINT_LIST_ITEM_REMOVE', opts)
  },
  // ======================================================================
  // ==========================Item Management=============================
  // ======================================================================
  boschpanelpointDetail (context, opts) {
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    const inputs = { }
    if (opts && Array.isArray(opts.populate) && opts.populate.length > 0) {
      inputs.params = { }
      inputs.params.populate = opts.populate
    }
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/boschpanelpoint/${id}`, inputs)
        .then(({ data }) => {
          context.commit('BOSCHPANELPOINT_CURRENT', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  boschpanelpointHistory (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/boschpanelpoint/history', { params: { id: opts } })
        .then(({ data }) => {
          context.commit('BOSCHPANELPOINT_CURRENT_HISTORY', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  boschpanelpointUpdate (context, opts) {
    const updates = Object.assign({}, context.state.update)
    for (const key of Object.keys(updates)) {
      if (updates[key] === null) {
        delete updates[key]
      }
    }
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/boschpanelpoint/${context.state.current.id}`, updates)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  bulkUpdatePanels (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .patch('/api/boschpanelpoint/bulkupdate', opts)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  }
}
